import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NegotiationSidebar } from '@/areas/negotiations/Negotiations/components/NegotiationSidebar';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// The pages beside the negotiation's sidebar; the solution manager stays outside this group.
export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    return (
        <SidebarRouteLayout sidebar={<NegotiationSidebar negotiationId={negotiationId} />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
